<template>
  <div class="table" v-loading="tableLoading" ref="tablePage">
    <vxe-grid v-bind="gridOptions" ref="xGrid" keep-sourece :edit-rules="validRules" :show-header-overflow="true"
      :print-config="{}" @edit-closed="updateDatacc" :toolbar-config="tableToolbar"
      @toolbar-tool-click="toolbarToolClickEvent" @edit-actived="editActivedEvent" @cell-click="cellClickEvent"
      @checkbox-change="selectChangeEvent" @current-change="currentChangeEvent">
      <template #toolbar_buttons>
        <el-button @click="addData" :disabled="getEditPriv()" class="btn btn1" icon="el-icon-circle-plus-outline">
          {{ $t("message.button.add") }}
        </el-button>
        <el-button @click="deleteSchedule" :disabled="getEditPriv()" class="btn btn8" icon="el-icon-document-delete">{{
          $t("message.button.delete") }}
        </el-button>

        <el-dropdown :disabled="signoffButton || !isExecuter || isComplete || nextStateBtnDisable
          " :class="StatusBtn || !isExecuter || isComplete || nextStateBtnDisable
            ? 'next-status-btn'
            : ''
            " split-button @click="NextState" size="small" style="margin-left: 10px" @command="goToState">
          <span>
            {{ $t("message.title.manualNextStatus") }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="status in statusInfo" :key="status.id" :command="status.id"
              :disabled="status.hasPriv == 0 || !isExecuter">{{ status.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="btn btn5" icon="el-icon-share" style="margin-left: 10px" @click="scheduleConfirmShow = true"
          v-if="isRoot && !noImport" :disabled="getEditPriv()">{{ $t("message.button.importRemak") }}
        </el-button>

        <el-button class="btn btn6" icon="el-icon-document-copy" style="margin-left: 10px" @click="fillFromTemp"
          :disabled="getEditPriv()">
          {{ $t("message.button.fill") }}
        </el-button>
      </template>
      <template #tools>
        <el-button @click="submit" :disabled="getEditPriv()" class="btn btn7" icon="el-icon-document-checked">{{
          $t("message.button.save") }}
        </el-button>
        <el-button @click="reload" :disabled="getEditPriv()" class="btn btn8" style="margin-right: 15px"
          icon="el-icon-circle-close">{{ $t("message.button.cancel") }}
        </el-button>
      </template>

      <template>
        <vxe-column type="checkbox" width="60"></vxe-column>
      </template>

      <template #nameDefault="{ row }">
        <div class="name-squ" v-show="!!row.id" :style="{
          backgroundColor: getColor(row.specialState, row.statusType),
        }"></div>
        <span :class="{ link_: row.id }" style="margin-left: 5px; margin-top: -3px"
          @click="showDetailEvent(row, column)">{{ getName(row) }}</span>
      </template>

      <template #cascadeShow="{ row }">
        {{ getCascaderLabel(row) }}
      </template>
      <template #cascadeEdit="{ row }">
        <el-cascader v-model="row['1054008']" :options="cascaderList" :show-all-levels="false" clearable
          :props="cascaderProps" ref="cascaderAddr" @change="
            (e) => {
              getPreTask(e, row);
            }
          ">
          <template slot-scope="{ node, data }">
            <span>{{ data.label }}</span>
            <!-- <span v-if="node.isLeaf && isDemoTenant">
              <el-checkbox v-model="data.checked" size="mini" style="margin-left: 10px;">
                <span style="font-size: 12px;margin-left: -6px">强制依赖</span>
              </el-checkbox>
            </span> -->
          </template>
        </el-cascader>
      </template>

      <template #startDateShow="{ row }">
        <i class="el-icon-date" style="color: #c0c4cc; margin: 0 6px"></i>{{ formatDate(row["1054009"], "yyyy-MM-dd") }}
      </template>
      <template #startDateEdit="{ row }">
        <el-date-picker v-model="row['1054009']" type="date" @change="startTimeChange(row)"
          :picker-options="pickerOptionsStart" format="yyyy-MM-dd" :clearable="false"></el-date-picker>
      </template>

      <template #endDateShow="{ row }">
        <i class="el-icon-date" style="color: #c0c4cc; margin: 0 6px"></i>{{ formatDate(row["1054010"], "yyyy-MM-dd") }}
      </template>
      <template #endDateEdit="{ row }">
        <el-date-picker v-model="row['1054010']" type="date" @change="endTimeChange(row)"
          :picker-options="pickerOptionsEnd" format="yyyy-MM-dd" :clearable="false"></el-date-picker>
      </template>

      <template #startDateShowACT="{ row }">
        <i class="el-icon-date" style="color: #c0c4cc; margin: 0 6px"></i>{{ formatDate(row["1054012"], "yyyy-MM-dd") }}
      </template>
      <template #startDateEditACT="{ row }">
        <el-date-picker v-model="row['1054012']" type="date" @change="startTimeChangeACT(row)"
          :picker-options="pickerOptionsStartACT" format="yyyy-MM-dd"></el-date-picker>
      </template>

      <template #endDateShowACT="{ row }">
        <i class="el-icon-date" style="color: #c0c4cc; margin: 0 6px"></i>{{ formatDate(row["1054013"], "yyyy-MM-dd") }}
      </template>
      <template #endDateEditACT="{ row }">
        <el-date-picker v-model="row['1054013']" type="date" @change="endTimeChangeACT(row)"
          :picker-options="pickerOptionsEndACT" format="yyyy-MM-dd"></el-date-picker>
      </template>

      <template #duration="{ row }">
        <span>{{ getDuration(row) }}</span>
      </template>
      <template #editDuration="{ row }">
        <!-- <span>{{ getDuration(row) }}</span> -->
        <el-input v-model="getDurationVal" @change="
          (val) => {
            setScheduleDate(val, row);
          }
        "></el-input>
      </template>

      <template #actualCost="{ row }">
        <span>￥{{ actualCostAmount(row) }}</span>
      </template>
      <template #budgetedCost="{ row }">
        <span>￥{{ budgetedCostAmount(row) }}</span>
      </template>
    </vxe-grid>

    <el-dialog v-if="scheduleConfirmShow" class="searchAddBomList" :title="$t('message.list.scheduleCommentsTemplate')"
      :visible.sync="scheduleConfirmShow" @close="scheduleConfirmShow = false">
      <ScheduleConfirm :tableData="baseData" @close="closeSchCon"></ScheduleConfirm>
    </el-dialog>

    <vxe-modal v-model="executorView" v-if="executorView" :title="$t('message.list.team')" width="800" resize
      destroy-on-close @close="handleClose">
      <template #default>
        <executorHandle ref="executor" :tableInfo="tableInfo" :rowInfo="rowInfo" @executorReload="executorReload">
        </executorHandle>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import axios from "axios";
import Sortable from "sortablejs";
import { ACTIVE_LIST, compareArr } from "./config";
import XEUtils, { toDateString } from "xe-utils";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import ScheduleConfirm from "./scheduleConfirm.vue";
import executorHandle from "../team.vue";

export default {
  data() {
    return {
      tempCell: {},
      tableData: [],
      tableHeight: 0,
      showHelpTip: false,
      regionList: [],
      tableLoading: false,
      nextStateBtnDisable: false,
      getDurationVal: "",
      componentname: this.$route.matched[1].path.slice(1),

      tableToolbar: {
        print: false,
        export: true,
        zoom: true,
        custom: true,
        slots: {
          buttons: "toolbar_buttons",
          tools: "tools",
        },
      },
      gridOptions: {
        resizable: true,
        border: true,
        showOverflow: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        keepSource: true,
        // rowId: 'id',
        height: 590,

        treeConfig: { children: "children", expandAll: true },
        exportConfig: {
          isAllExpand: true,
        },
        expandConfig: {
          expandAll: true,
          reserve: true,
        },
        editConfig: {
          trigger: "click",
          mode: "cell",
          activeMethod: this.activeCellMethod,
        },
        cellStyle: this.cellStyle,

        checkboxConfig: {
          checkStrictly: true,
          // labelField: 1054001,
          checkMethod: this.checCheckboxkMethod,
        },
        columns: [],
        customConfig: { checkMethod: this.customCheck },
      },
      // proTaskList: [],
      validRules: {
        1054001: [
          { required: true, message: this.$t("message.warning.required") },
          // { validator: nameValid }
        ],
        1054006: [
          { required: true, message: this.$t("message.warning.required") },
          // { validator: nameValid }
        ],
        // 1054038: [
        //   { required: true, message: this.$t("message.warning.required") },
        //   // { validator: nameValid }
        // ],
        // 1054039: [
        //   { required: true, message: this.$t("message.warning.required") },
        //   // { validator: nameValid }
        // ],
        // 1054009: [
        //   { required: true, message: this.$t("message.warning.required") },
        //   // { validator: datetimeValid },
        // ],
        // 1054010: [
        //   { required: true, message: this.$t("message.warning.required") },
        //   // { validator: datetimeValid },
        // ],
      },

      Pid: 0,
      // fixed: "left",
      fixColumn: [
        { type: "checkbox", width: 60, field: "checkbox" },
        { title: "WBS", width: 70, field: "seq" },
        // {title: "isLeaf", width: 70, field:'isLeaf'},
      ],

      newData: [],
      changData: [],
      selectRow: "",
      scheduleList: [],
      schItem: {},
      subList: [],
      drop: false,
      editableList: [],
      columnList: [],
      rootId: "",
      rowList: [],
      rowInfo: {},

      budgetedCosts: [],
      actualCosts: [],
      currencyList: [],

      StatusBtn: true,
      signoffButton: false,
      statusInfo: [],
      changeTableCellObjId: "",

      editTable: true, //暂停和取消静止事件操作
      btnEditTable: true, //暂停禁止按钮操作
      btnIsProjectAdmin: false, //是否为项目负责人
      btnIsAdmin: true, //是否为项目经理
      isExecuter: true, //是否为执行者
      isComplete: false, //是否完成
      noImport: true,
      tempId: 0,
      exportedBom: [],

      baseData: [],

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      allProList: [],
      cascaderProps: {
        multiple: true,
      },
      taskRow: {},

      scheduleConfirmShow: false,
      isRoot: false,
      executorView: false,
      executorUpdate: false,

      seqSelected: [""],

      calendarList: [],
      cList: [],
      pickerOptionsStart: {
        // disabledDate: () =>{},
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time),
      },
      pickerOptionsEnd: {
        // disabledDate: () =>{},
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time),
      },

      pickerOptionsStartACT: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time),
      },
      pickerOptionsEndACT: {
        disabledDate: (time) => {
          const timeData = this.testData[1054012];
          if (Date.parse(timeData)) {
            return time.getTime() < Date.parse(timeData) - 24 * 60 * 60 * 1000;
          } else {
            return true;
          }
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time),
      },
      testData: [],
      isDemoTenant: true,
      objectId: { ...this.$store.state.objectId },
    };
  },
  props: ["tableInfo"],
  components: { ScheduleConfirm, executorHandle },

  methods: {
    getEditPriv() {
      return !this.editTable || !this.btnEditTable || !this.btnIsAdmin;
    },

    getPreTask(e, row) {
      if (!this.isDemoTenant) {
        return;
      }
      //  const arr = e.map(i => i.at(-1));
      // const date = this.getLastDate(arr) + 24 * 60 * 60 * 1000
      // row['1054009'] = new Date(date);
      // this.startTimeChange(row);
    },
    getLastDate(arr) {
      const list = arr.map((i) => {
        const row = this.getRow(this.tableData, i)[0];
        return Date.parse(row["1054010"]);
      });
      const max = Math.max(...list);
      return max;
    },

    fillFromTemp() {
      const { row, column, rowIndex, columnIndex } = this.tempCell;

      let list = this.$refs.xGrid.getCheckboxRecords();
      const colProId = column.property;

      if (list.length) {
        list.map((i) => {
          i[colProId] = row[colProId];
          const obj = { id: i.id, [colProId]: row[colProId] };
          this.changData.push(obj);
        });
        // this.updateDatacc({row:i,column})
        return;
      }
      list = this.getAllRow(this.gridOptions.data);
      const rowKey = Number(row["_X_ROW_KEY"].replace("row_", ""));
      list.map((i, e) => {
        const key = Number(i["_X_ROW_KEY"].replace("row_", ""));
        const getEditable = this.cellClickEvent({ row: i, column });
        if (key > rowKey && getEditable !== false) {
          i[colProId] = row[colProId];
          const obj = { id: i.id, [colProId]: row[colProId] };
          this.changData.push(obj);
        }
      });
    },
    checCheckboxkMethod({ row }) {
      const selectedRow = this.seqSelected[0];
      let checkConfig =
        !selectedRow ||
        this.selectedList.some((i) => i.id == row.id) ||
        row.parentId == selectedRow.parentId;
      return (
        checkConfig &&
        row.id !== this.rootId &&
        this.rowList.includes(row.id) &&
        row.statusId != 3
      );
    },
    // showCheckboxkMethod({ row }) {
    //   return row.id !== this.rootId;
    // },
    selectChangeEvent({ row, checked }) {
      if (checked) {
        this.seqSelected.unshift(row);
      } else {
        const n = this.seqSelected.findIndex((i) => i.seq == row.seq);
        this.seqSelected.splice(n, 1);
      }
      this.selectedList = this.getPar(
        this.gridOptions.data,
        this.seqSelected[0]
      );
      this.selectedList.length && this.selectedList.pop();
    },

    closeSchCon() {
      this.scheduleConfirmShow = false;
    },
    goToState(num) {
      this.updateTableState(num);
    },
    NextState() {
      if (this.isComplete || this.nextStateBtnDisable) {
        return false;
      }
      if (this.statusInfo.length) {
        this.updateTableState(this.statusInfo[0].id);
      }
    },

    toolbarToolClickEvent({ code }) {
      const $grid = this.$refs.xGrid;
      switch (code) {
        case "myPrint":
          $grid.print();
          break;
      }
    },

    customCheck(e) {
      const arr = Object.keys(this.validRules);
      return !arr.includes(e.column.property);
    },

    getCascadeValue() {
      let row = this.tempData["row"];
      let column = this.tempData["column"];
      row[[column.property]] = this.cascaderValue.map((i) => i[i.length - 1]);

      // const valueList = this.cascaderValue.map((i) => i[i.length - 1]);
      // const labelList = this.$refs['cascaderAddr'].presentTags    // 获取label值
      // let currentOptions = [];
      // valueList.map((i,e) =>{currentOptions.push({'value':i,'label':labelList[e].text})})
      // column.editRender.options =[...column.editRender.options,...currentOptions];
      // row[[column.property]] = valueList;

      this.closeCascaderShow();
    },
    updateDatacc({ row, column }) {
      this.$store.commit("setPageChanged", {
        name: this.componentname,
        isChanged: true,
      });

      let propertyId = column.property;
      if (propertyId == "1054009" && row[propertyId].getHours() != 8) {
        this.startTimeChange(row);
      } else if (propertyId == "1054010" && row[propertyId].getHours() != 8) {
        this.endTimeChange(row);
      }
      this.currencyList.includes(Number(propertyId)) &&
        this.getCostConvolution(row, column);
      if (row.id) {
        let obj = { id: row.id, [[propertyId]]: row[propertyId] };
        if (["1054009", "1054010"].includes(propertyId)) {
          let n =
            this.countWorkDay(row["1054009"], row["1054010"]) *
            (8 * 60 * 60 * 1000) || 0;
          Object.assign(obj, { 1054011: n });
        }
        this.changData.push(obj);
      }

      if (row.classId == "30102") {
        row["1054009"] = "";
        row["1054011"] = "";
      }
    },
    closeCascaderShow() {
      this.cascaderShow = false;
      this.cascaderValue = [];
      // this.getRow(this.cascaderList, this.taskRow.id)[0].disabled = false;
    },

    cellClickEvent({ row, column, rowIndex, columnIndex }) {
      if (!this.rowList.includes(row.id)) {
        // this.btnIsAdmin = false;
        // // this.$message.error("请到父级/根目录下进行操作");
        // this.isExecuter = false;
        return false;
      }
      if (
        row.classId == "30102" &&
        this.currencyList.includes(Number(column.property))
      ) {
        return false;
      }

      let userId = window.sessionStorage.getItem("userContext");
      userId = JSON.parse(userId).id;

      let isAdmin = row["1054004"]
        ? row["1054004"].includes(userId + "")
        : false;
      let isDirector = row["1054003"]
        ? row["1054003"].includes(userId + "")
        : false;

      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (
        row.createdBy == userId ||
        this.gridOptions.data[0].createdBy == userId ||
        isAdmin ||
        isDirector ||
        isSupAdmin
      ) {
        this.btnIsAdmin = true;
      } else {
        this.btnIsAdmin = false;
      }

      // if (column.property == 1054008) {
      //   this.getRow(this.proTaskList, row.id)[0].disabled = true;
      //   this.cascaderList = this.proTaskList;
      //   let newRow = row[[column.property]];
      //   this.cascaderValue = newRow;
      //   // this.cascaderValue = newRow ? newRow.map((i) => { return this.getParentIdList(this.cascaderList, i)}) : ''
      //   this.cascaderProps.multiple = true;
      //   // this.cascaderProps.checkStrictly= true;
      //   this.tempData = { row, column };
      //   this.cascaderShow = true;
      //   this.taskRow = row;
      // }

      // if (this.tempId != row.id && row.isLeaf) {
      //   this.changeTableCellObjId = row.id;
      //   this.loadTableStates(row.id);
      // }
      // if (this.tempId != row.id) {
      if (row.isLeaf) {
        this.changeTableCellObjId = row.id;
        this.loadTableStates(row.id);
        this.loadGetExecuters(row);
      } else {
        //禁用操作状态按钮
        this.disableTableStates();
      }
      [1054003, 1054002, 1054004, 1054071].includes(
        Number(column["property"])
      ) && (this.tempCell = { row, column, rowIndex, columnIndex });
      // };
      // this.tempId = row.id;
    },
    calendarDate(time) {
      if (this.cList.includes(this.getLocalTime(time.getTime()))) {
        if ([0, 6].includes(time.getDay())) {
          return "date-pick-workday";
        } else {
          return "date-pick-holiday";
        }
      }
      if (
        [0, 6].includes(time.getDay()) &&
        !this.cList.includes(this.getLocalTime(time.getTime()))
      ) {
        return "date-pick-holiday";
      }
    },
    loadGetExecuters(row) {
      if (!row.id) {
        return;
      }
      var obj_get = {
        id: row.id,
        classId: row.classId,
        subClassId: row.subclassId,
      };
      axios
        .get(`ppm/project/getExecuters${this.params(obj_get)}`)
        .then((res) => {
          let userList = [];
          res.data.object.executers?.map((item) => {
            userList.push(item.id);
          });
          let userId = window.sessionStorage.getItem("userContext");
          userId = JSON.parse(userId).id;
          let userIndex_ = userList.indexOf(userId);
          if (userIndex_ == -1 && !this.btnIsAdmin) {
            //判断是不是项目执行者操作下一状态
            this.isExecuter = false;
          } else {
            this.isExecuter = true;
          }
        });
    },

    getDuration(row) {
      let strE = row["1054010"].toString();
      let colonIndexE = strE.indexOf(":");
      let newStrE =
        strE.substring(0, colonIndexE - 2) + "00" + strE.substring(colonIndexE);

      let n = !row["1054009"]
        ? ""
        : this.countWorkDay(new Date(row["1054009"]), new Date(newStrE));
      return n;
    },

    actualCostAmount(row) {
      return this.costConvolution(this.actualCosts, row);
    },
    budgetedCostAmount(row) {
      return this.costConvolution(this.budgetedCosts, row);
    },

    loadTableStates(objId) {
      if (!objId) {
        return;
      }
      this.statusInfo = [];
      axios
        .get("/ppm/project/getProjectStatusListById?id=" + objId)
        .then((res) => {
          const StatusListLength = res.data.object.projectStatusList.length;

          this.StatusBtn = !StatusListLength;
          this.signoffButton = !!StatusListLength;
          this.statusInfo = res.data.object.projectStatusList || [];

          this.isComplete =
            res.data.object.currectStatus.statusType == 3 ||
              res.data.object.currectStatus.statusType == 4
              ? true
              : false;
          this.nextStateBtnDisable =
            StatusListLength &&
            res.data.object.projectStatusList[0].hasPriv == 0;
        });
    },
    //下一状态置灰
    disableTableStates() {
      this.StatusBtn = true;
      this.signoffButton = false;
      this.statusInfo = [];
    },

    getScheduleInfo() {
      this.tableLoading = true;
      axios
        .get("pmdm/admin/cls/getProjectClsesWithSubClses?baseClsId=301")
        .then((res) => {
          const { clses } = res.data.object;
          this.subList = clses.map((i) => {
            const options = i.children.map((j) => {
              return {
                label: j.name,
                value: j.id + "",
                disabled: !parseInt(j.actived),
              };
            });
            return { label: i.name, options, classId: i.id };
          });
          const obj_get = {
            ...this.objectId,
            tableId: 54,
          };
          return axios.get(
            `/ppm/project/getScheduleTableList${this.params(obj_get)}`
          );
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.newData = [];
            const {
              isRollUp,
              rows: arr,
              columnInfo: n,
            } = res.data.object.table;
            // const arr = res.data.object.table.rows;
            this.rootId = arr[0].objId;
            this.isRoot = this.rootId == this.objectId.id;
            // const n = res.data.object.table.columnInfo;
            this.columnList = n;
            this.isRollUp = isRollUp;

            this.editableList = arr;
            Object.keys(n.listEntries).map((i) => {
              const e = n.listEntries[i];
              n.listEntries[i] = Object.keys(e).map((j) => {
                return { label: e[j], value: j + "" };
              });
            });
            const typeList = {
              1: { name: "input", attrs: { type: "text" } },
              3: {
                name: "$select",
                props: {
                  clearable: true,
                  filterable: true,
                },
              },
              4: {
                name: "$select",
                props: {
                  clearable: true,
                  multiple: true,
                  filterable: true,
                },
              },
              6: {
                name: "$input",
                props: {
                  type: "date",
                  // disabledMethod: this.disabledEndDateMethod,
                },
              },
              7: { name: "$input", props: { type: "number" } },
              10: { name: "$input", props: { type: "number" } },
            };
            this.scheduleList = n.names.map((i, e) => {
              return {
                title: i,
                field: n.ids[e].toString(),
                editRender: this.deepCopy(typeList[n.uiTypes[e]]),
                uiType: n.uiTypes[e],
                width: [7, 8, 10].includes(n.uiTypes[e]) ? 80 : 140,
              };
            });
            this.scheduleList.filter((i, e) => {
              if (n.uiTypes[e] == 3 || n.uiTypes[e] == 4) {
                const k = n.listEntries[n.listIds[e]] || [];

                i.editRender.options = this.deepCopy(k);
                if (!n.listIds[e] || n.listIds[e] == -1) {
                  i.editRender.options = [];
                }
              }
            });

            this.scheduleList[1].width = 280;

            this.tableData = this.formattScheduleTable(arr);
            this.getItemSeq(this.tableData[0].children);

            this.baseData = this.deepClone(this.getAllRow(this.tableData));
            this.gridOptions.data = this.tableData;

            this.rowList = this.getChildrenIdList(
              this.getRow(this.tableData, this.objectId.id)
            );
            this.rowList.push("");
            let nameCol = this.findAttr("1054001");
            // nameCol.editRender.events = { blur : this.nameChangeEvent };
            nameCol.treeNode = true;
            nameCol.width = 280;
            // nameCol.fixed = "left";
            nameCol.slots = {
              default: "nameDefault",
            };

            const nameList = ["1055003", "1054003", "1054004", "1054069"];
            nameList.map((n) => {
              this.findAttr(n).editRender.options = [...this.ccList];
            });

            this.findAttr("1054006").editRender.optionGroups = this.subList;
            this.findAttr("1054006").editRender.events = {
              change: this.getProjectType,
            };
            this.findAttr("1054008").slots = {
              default: "cascadeShow",
              edit: "cascadeEdit",
            };
            this.findAttr("1054009").editRender.events = {
              change: this.startTimeChange,
            };
            this.findAttr("1054010").editRender.events = {
              change: this.endTimeChange,
            };

            this.findAttr("1054011").editRender = {
              name: "input",
              attrs: { type: "text" },
            };
            // this.findAttr("1054009").slots = { default: "startDate" };
            // this.findAttr("1054010").slots = { default: "endDate" };
            this.findAttr("1054009").slots = {
              default: "startDateShow",
              edit: "startDateEdit",
            };
            this.findAttr("1054010").slots = {
              default: "endDateShow",
              edit: "endDateEdit",
            };

            this.findAttr("1054012").slots = {
              default: "startDateShowACT",
              edit: "startDateEditACT",
            };
            this.findAttr("1054013").slots = {
              default: "endDateShowACT",
              edit: "endDateEditACT",
            };

            this.findAttr("1054011").slots = {
              default: "duration",
              edit: "editDuration",
            };

            let proNamelist = this.getProName(this.tableData);
            this.findAttr("1054052").editRender.options = proNamelist;

            const currencyList = [];
            n.uiTypes.map((i, e) => {
              if (i == 10) currencyList.push(n.ids[e]);
            });
            this.actualCosts = currencyList.filter((i) => !(i % 2));
            this.budgetedCosts = currencyList.filter((i) => i % 2);

            this.currencyList = currencyList;

            this.scheduleList
              .filter((i) => currencyList.includes(parseInt(i.field)))
              .map((j) => {
                return Object.assign(j, {
                  formatter: this.formatAmount,
                  editRender: {
                    name: "$input",
                    props: { type: "float", digits: 2 },
                    // events: { change: this.getCostConvolution },
                  },
                });
              });

            this.findAttr("1054018").slots = { default: "actualCost" };
            this.findAttr("1054019").slots = { default: "budgetedCost" };
            this.findAttr("1054071").editRender = {
              name: "$select",
              options: this.ccList,
              props: { multiple: true, filterable: true },
            };
            // this.proTaskList = this.formatList(this.deepCopy(this.tableData));
            // this.cascaderList = this.formatList(this.deepCopy(this.tableData))[0].children;
            this.cascaderList = this.getListLabel(this.tableData[0].children);

            this.allProList = this.getLeafArray(this.cascaderList).map((i) => {
              return {
                value: i.value,
                label: i.label + "(" + i.seq + ")",
                // label: this.getParentNameList(this.cascaderList, i.value).join(
                //   "/"
                // ) + '('+ i.seq +')',
              };
            });

            // this.findAttr("1054008").editRender = {
            //   name: "$select",
            //   props: {
            //     clearable: true,
            //     multiple: true,
            //   },
            // };
            // this.findAttr("1054008").editRender.options = this.getLeafArray(
            //   this.proTaskList
            // ).map((i) => {
            //   return {
            //     value: i.value,
            //     label: this.getParentNameList(this.proTaskList, i.value).join(
            //       "/"
            //     ),
            //   };
            // });
            // this.findAttr("1054008" ).formatter = this.formatDateDifference
            // this.gridOptions.columns=[...this.fixColumn,...this.scheduleList];
            this.gridOptions.columns = [
              ...this.fixColumn,
              ...this.scheduleList,
            ];
            // this.tableLoading = false;
            let row = this.getRow(this.tableData, this.objectId.id)[0];
            this.$refs.xGrid?.setCurrentRow(row);
          }
        })
        .finally((_) => {
          this.tableLoading = false;
        });
    },
    getColor(a, b) {
      //
      if (!a && a !== 0) {
        return "";
      }
      let n = !a ? (b < 4 ? 0 : b == 6 ? 1 : b == 4 ? 4 : 2) : a == 1 ? 3 : 4;

      const statusColor = [
        { id: 1, color: "#13ce66", name: "正常阶段" },
        { id: 2, color: "#fcad2c", name: "需要注意" },
        { id: 3, color: "#F56C6C", name: "延迟阶段" },
        { id: 4, color: "#38a8f6", name: "暂停任务" },
        { id: 5, color: "#999", name: "关闭任务" },
      ];
      return statusColor[n].color;
    },
    getTab() {
      let vm = this;
      axios
        .get("/pmdm/admin/getTab/" + this.objectId.subClassId)
        .then((res) => {
          let date_ = res.data.object.tabs;
          date_.map((item) => {
            if (item.id == "1030104") {
              vm.noImport = false;
            }
          });
        });
    },
    getProjectType(e, { column, row, cellValue }) {
      let id = e.row["1054006"];
      let n = this.subList.find((i) => {
        if (i.options.some((j) => j.value == id)) {
          return i.classId;
        }
      });
      e.row.classId = n.classId;
    },
    disStartDate() { },

    //表格重载
    reload() {
      // 清除所有状态
      this.changData = [];
      this.newData = [];
      this.selectedList = [];
      (this.seqSelected = [""]), this.$refs.xGrid.clearAll();
      this.$emit("routeClick");
      this.disableTableStates();
      this.tempCell = {};
      this.$store.commit("setPageChanged", {
        name: this.componentname,
        isChanged: false,
      });
      return this.getScheduleInfo();
    },
    executorReload() {
      this.executorUpdate = true;
    },

    // handleClose(){
    //   this.executorView = false;
    //   // this.executorUpdate && this.reload();
    //   let arr = this.$refs.executor.gridOptions.data.map(i => i.itemId);
    //   let row =  this.getRow(this.gridOptions.data, this.rowInfo.id)[0];
    //   row['1054071'] = arr;
    // },
    //表格拖动

    //清空真个表格
    deleteAllSchedule() {
      this.$confirm(
        this.$t("message.confirm.clearSchedule"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        axios
          .post(
            "/ppm/project/softDelScheduleByRootId?rootId=" + this.objectId.id
          )
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: res.data.message,
              });
              this.reload();
              this.disableTableStates();
            }
          });
      });
    },

    deleteSchedule() {
      const xGrid = this.$refs.xGrid;
      let allRows = xGrid.getCheckboxRecords();
      if (!allRows.length) {
        return;
      }

      const arr1 = allRows.filter((i) => i["_XID"]);

      arr1.map((row) => {
        const index = this.gridOptions.data.findIndex(
          (i) => i["_XID"] === row["_XID"]
        );

        xGrid.remove({ row }).then((res) => {
          this.gridOptions.data.splice(2, 1);
        });
      });

      const rows = allRows.filter((i) => !i["_XID"]);

      if (!rows.length) {
        return;
      }

      const idList = rows.map((i) => i.id);
      if (idList.includes(this.objectId.id)) {
        // this.$message.error('请到父级计划页下删除本任务')
        this.$message.error(this.$t("message.tips.del_01"));
        return;
      }
      const arr = rows.map((i) => {
        i.level = i.seq.split(".").length;
        return i.level;
      });
      const mixLevel = Math.min(...arr);
      const filterRows = rows.filter((i) => i.level == mixLevel);

      const msgArr = filterRows
        .filter((i) => i.statusId == 2)
        .map((i) => i["1054001"]);
      const confirmMsg =
        msgArr.join("、") + " " + this.$t("message.confirm.taskDeleteData");

      const msg = msgArr.length
        ? confirmMsg
        : this.$t("message.confirm.deleteObject");

      this.sentDelete(filterRows, msg);
    },
    sentDelete(rows, msg) {
      this.$confirm(msg, this.$t("message.tips.tip"), {
        confirmButtonText: this.$t("message.button.affirm"),
        cancelButtonText: this.$t("message.button.cancel"),
        type: "warning",
      })
        .then((res) => {
          let subStr = rows.map((i) => i.id).join(",");
          const idList = rows.map((i) => i.id);
          axios
            .post("/ppm/project/softDelScheduleById?id=" + subStr)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
                const { classId, subClassId } = this.objectId;
                this.$store.dispatch("filterTabs", {
                  idList,
                  classId,
                  subClassId,
                });
                this.reload();
                this.$parent.$emit("refresh", this.rootId);

                const arr = rows.map((i) => ({
                  projectId: i.id,
                  classId: i.classId,
                }));

                const systemCode =
                  window.sessionStorage.getItem("systemCode") || "";
                if (systemCode.indexOf("medlinket") !== -1) {
                  return axios.post(
                    `/ppm/project/removeRelationshipValue`,
                    arr
                  );
                }
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },

    cellStyle({ row, rowIndex, column }) {
      if (!this.rowList.includes(row.id)) {
        return {
          backgroundColor: "#f9f9f9",
          // color: '#e4e7ed'
          cursor: "not-allowed",
        };
      }
    },

    currentChangeEvent({ row }) {
      if (this.rowList.includes(row.id)) {
        return false;
      }
    },

    // 添加子任务
    addData() {
      const row = this.$refs.xGrid.getCurrentRecord();
      if (row == null) {
        this.$message.error(this.$t("message.tips.selcetParentProject"));
        return;
      }
      // if (!this.rowList.includes(row.id)) {
      //   // this.$message.error("请到父级/根目录下进行操作");
      //   return;
      // }
      if (!row.id) {
        //  "请先保存当前行"
        this.$message.error(this.$t("message.tips.saveCurrentRow"));
        return;
      }

      if (this.subList[1].options.find((i) => i.value == row["1054006"])) {
        // "关卡/里程碑 下不可添加子任务";
        this.$message.error(this.$t("message.tips.add_01"));
        return;
      }
      if (row.statusId == 3) {
        this.$message.error(this.$t("message.tips.add_03"));
        return;
      }
      // let obj = {
      //   arr: this.gridOptions.data,
      //   value: row._XID,
      //   item: {},
      // };
      let newRow = {
        id: "",
        parentId: row.id,
        isLeaf: 1,
        _XID: "row_" + new Date().getTime(),
        _X_ROW_KEY: "row_" + new Date().getTime(),
        classId: row.classId,
        subclassId: "",
      };
      let arr = [
        // "1054011",
        "1054003",
        "1054005",
        "1054015",
        "1054004",
        "1054009",
        "1054010",
        "1054038",
        "1054039",
      ];

      arr.map((i) => (newRow[i] = row[i]));
      newRow["1054006"] = "3010104";
      newRow["1054071"] = [];
      newRow.subclassId = newRow["1054006"];
      // obj.item = newRow;
      // this.gridOptions.data = this.addChildren(obj);
      row.children.push(newRow);
      this.getItemSeq(this.tableData[0].children);
      if (row.id) {
        this.newData.push(row.children[row.children.length - 1]);
      }
      // 修改叶子节点
      if (row.isLeaf == 1) {
        row.isLeaf = 0;
        this.changData.push({ id: row.id, isLeaf: 0 });
      }
      this.$refs.xGrid.setActiveRow(newRow);
    },

    // 以下3个函数为提交时触发，updateData 数据更新  insertData 数据添加
    async submit() {
      let arr = this.newData.map((i) => {
        i["1054011"] = !i["1054009"]
          ? 0
          : this.countWorkDay(i["1054009"], i["1054010"]) *
          (8 * 60 * 60 * 1000);
        return this.subDataFormat(i);
      });

      let errList = this.validNewArr(arr);
      if (!!errList.length) {
        //"当前任务下不可以只有关卡/里程碑");
        this.$message.error(this.$t("message.tips.add_02"));
        return;
      }

      const $table = this.$refs.xGrid;
      const errMap = await $table.fullValidate().catch((errMap) => errMap);
      const errMapNew = await $table
        .fullValidate(arr)
        .catch((errMap) => errMap);
      if (errMap || errMapNew) {
        this.$message.error(this.$t("message.warning.required"));
        return;
      }

      //计划页签中清空实际开始时间后页面上显示实际结束时间为空但保存后还会显示实际结束时间
      //不知道什么问题导致，先手动把值给空
      if (
        this.changData &&
        this.changData[0] &&
        this.changData[0][1054012] == ""
      ) {
        this.changData[0][1054013] = "";
      }

      const obj = {
        updateSchedule: this.arrayFilter(this.changData)
          .map((i) => this.subDataFormat(i))
          .filter((i) => i.id),
        insertSchedule: arr,
        rootId: this.rootId,
      };

      let checkStartDate = true;

      const checkList = [...obj.updateSchedule, ...obj.insertSchedule];

      for (let i = 0; i < checkList.length; i++) {
        const el = checkList[i];

        if (Object.prototype.hasOwnProperty.call(el, '1054009')) {
          if ((!el['1054009'] || el['1054009'] == 'Invalid Date') && (el['1054006'] != '3010201' && el['1054006'] != '3010202')) {
            checkStartDate = false
            break
          }
        }

      }
      if (!checkStartDate) {
        this.$message.error('计划开始时间不能为空')
        return
      }

      axios.post("/ppm/project/saveOrUpdateSchedule", obj).then((res) => {
        this.$message({
          type: "success",
          message: res.data.message,
        });

        if (!this.$refs.xGrid.isMaximized()) {
          this.$parent.$emit("refresh", this.rootId);
          this.$emit("reloadProgress");
        }
        const n = obj.updateSchedule.find((i) => i.id == this.objectId.id);
        const upDateName = n ? (n["1054001"] ? n["1054001"] : "") : "";
        !!upDateName && this.replaceTabsName(upDateName);
        this.updateRelationshipValue(obj);
        this.reload();

        this.$store.commit("setPageChanged", {
          name: this.componentname,
          isChanged: false,
        });
      });
    },

    updateRelationshipValue(obj) {
      const { updateSchedule, insertSchedule } = obj;
      const arr = [...updateSchedule, ...insertSchedule];
      const hasExecutor = arr.some((i) => {
        return Object.keys(i).includes("1054071");
      });

      if (!hasExecutor) {
        return;
      }

      const systemCode = window.sessionStorage.getItem("systemCode") || "";
      if (systemCode.indexOf("medlinket") === -1) {
        return;
      }
      const { id } = this.objectId;
      axios.post(`/ppm/project/updateRelationshipValue?projectId=${id}`);
    },

    getCostConvolution(row, column) {
      const n = row.id || row.parentId;
      const parList = this.getParentIdListById(this.gridOptions.data, n);

      row.id && parList.splice(parList.indexOf(row.id), 1);
      parList.reverse();

      for (let i = 0; i < parList.length; i++) {
        const e = parList[i];
        let parRow = this.getRow(this.gridOptions.data, e)[0];
        let arr = parRow.children.map((j) => parseFloat(j[column.property]));
        parRow[column.property] = this.sum(arr);
      }
    },
    startTimeChangeACT(row) {
      row[1054013] = "";
      if (row[1054012]) {
        const date = new Date(row[1054012]);
        date.setHours(8, 0, 0, 0);
        row[1054012] = date;
      } else {
        row[1054012] = "";
      }
    },

    endTimeChangeACT(row) {
      if (row[1054013]) {
        const date = new Date(row[1054013]);
        date.setHours(8, 0, 0, 0);
        row[1054013] = date;
      } else {
        row[1054013] = "";
      }
    },

    //计划开始时间卷积
    startTimeChange(row) {
      // const t = this.getWorkDay(row["1054009"]);
      let t = row["1054009"];
      row["1054009"] = new Date(
        Date.parse(t) + -t.getTimezoneOffset() * 60 * 1000
      );
      // const parId = !row.id ? parList[parList.length - 1] : parList[parList.length - 2]
      // 计划开始时间不得晚于计划结束时间
      if (Date.parse(row["1054009"]) > Date.parse(row["1054010"])) {
        //"计划开始日期不得晚于计划结束日期");
        this.$message.error(this.$t("message.tips.date_01"));
        row["1054009"] = row["1054010"];
      }
      if (this.isRollUp) {
        // 计划开始时间 向父项目卷积
        const parList = this.getPar(this.gridOptions.data, row);
        row.id && parList.shift();
        parList.map((i) => {
          // let row = this.getRow(this.gridOptions.data, i)[0];
          i["1054009"] = i.children
            .map((j) => j["1054009"])
            .filter((v) => !!v)
            .sort((a, b) => a - b)[0];
        });
      } else {
        let parRow = this.getRow(this.tableData, row.parentId)[0];
        let childrenRows = this.getAllRow(row.children);
        let minDate = Date.parse(
          childrenRows
            .filter((i) => i["1054009"])
            .map((i) => i["1054009"])
            .sort((a, b) => a - b)[0]
        );

        if (Date.parse(row["1054009"]) > minDate) {
          // 当前状态下，计划开始日期不得晚于任务的计划开始日期");
          this.$message.error(this.$t("message.tips.date_02"));
          row["1054009"] = new Date(minDate);
          return;
        }
        if (
          row.seq &&
          Date.parse(row["1054009"]) < Date.parse(parRow["1054009"])
        ) {
          // "当前状态下，计划开始日期不得早于父任务开始日期");
          this.$message.error(this.$t("message.tips.date_03"));
          row["1054009"] = parRow["1054009"];
        }

        childrenRows.map((i) => {
          const baseRow = this.getRow(this.baseData, i.id)[0];

          if (i.statusId !== 3) {
            i["1054009"] =
              Date.parse(row["1054009"]) > Date.parse(baseRow["1054009"])
                ? row["1054009"]
                : baseRow["1054009"];
          }
        });
      }
    },

    //计划结束时间卷积
    endTimeChange(row) {
      // const t = this.getWorkDay(row["1054010"]);
      let t = row["1054010"];
      row["1054010"] = new Date(
        Date.parse(t) + -t.getTimezoneOffset() * 60 * 1000
      );
      // 计划开始时间不得早于计划结束时间
      if (Date.parse(row["1054009"]) > Date.parse(row["1054010"])) {
        // "计划结束日期不得早于计划开始日期");
        this.$message.error(this.$t("message.tips.date_04"));
        row["1054010"] = row["1054009"];
      }

      if (this.isRollUp) {
        //累积日期为 "是"
        const parList = this.getPar(this.gridOptions.data, row);
        row.id && parList.shift();
        parList.map((i) => {
          // let row = this.getRow(this.gridOptions.data, i)[0];
          i["1054010"] = i.children
            .map((j) => j["1054010"])
            .sort((a, b) => b - a)[0];
        });
      } else {
        //累积日期为 "否"
        let parRow = this.getRow(this.tableData, row.parentId)[0];
        let childrenRows = this.getAllRow(row.children) || [];
        let maxDate = Date.parse(
          childrenRows.map((i) => i["1054010"]).sort((a, b) => b - a)[0]
        );

        if (Date.parse(row["1054010"]) < maxDate) {
          // "当前状态下，计划结束日期不得早于子任务的计划结束日期");
          this.$message.error(this.$t("message.tips.date_05"));
          row["1054010"] = new Date(maxDate);
          return;
        }

        let dataState = this.compareDates(row["1054010"], parRow["1054010"]);
        if (row.seq && dataState) {
          // "当前状态下，计划结束日期不得晚于父项计划结束日期");
          this.$message.error(this.$t("message.tips.date_06"));
          row["1054010"] = parRow["1054010"];
        }
        // let chilrenIdList = this.getChildrenIdList(row.children) || [];
        childrenRows.map((i) => {
          const baseRow = this.getRow(this.baseData, i.id)[0];
          // let currentRow = this.getRow(this.gridOptions.data, i)[0];
          if (i.statusId !== 3) {
            i["1054010"] =
              Date.parse(row["1054010"]) < Date.parse(baseRow["1054010"])
                ? row["1054010"]
                : baseRow["1054010"];
          }
          // if (Date.parse(row["1054010"]) < Date.parse(baseRow["1054010"])) {
          //   i["1054010"] = row["1054010"];
          // } else {
          //   i["1054010"] = baseRow["1054010"];
          // }
        });
      }
    },
    //比较当前节点与其父节点的计划结束时间
    compareDates(dateStr1, dateStr2) {
      const a = dateStr1.toDateString();
      const b = dateStr2.toDateString();

      return Date.parse(a) > Date.parse(b);

      // if (a === b) {
      //   return 1; //年月日相同
      // } else if (a > b) {
      //   return 2; //大于父的年月日
      // } else {
      //   return 3;
      // }
    },

    getName(row, column) {
      return row["1054001"];
    },

    rowDrop() {
      const el = document.querySelector(
        "tbody"
      ) || document.querySelector('vxe-table--layout-wrapper');
      console.log(el);

      this.$nextTick(() => {
        const xTable = this.$refs.xGrid;
        new Sortable(el, {
          group: {
            name: "shared",
            // pull: "clone",
            // put: false, // 不允许拖拽进这个列表
          },
          animation: 150,
          sort: true, // 设为false，禁止sort

          // onStart:(){},
          setData: (el) => {
            // console.log(el);
            // const el = dataTransfer.setData('Text', dragEl.textContent); 
          },
          onMove: (event) => {
            // console.log('on move', event);

            const { dragged, related, willInsertAfter } = event;
            // console.log(dragged, related);
            // console.log(willInsertAfter);


            const dragElClassList = [];

            const { _prevClass: drag_class, id } = dragged,
              { _prevClass: related_class } = related;

            // console.log({ id, drag_class, related_class });


            return drag_class === related_class;

            // dragged.classList.forEach((element) => {
            //   if (element.includes("row--level")) {
            //     dragElClassList.push(element);
            //   }
            // });
            // const relatelClassList = [];
            // related.classList.forEach((element) => {
            //   if (element.includes("row--level")) {
            //     relatelClassList.push(element);
            //   }
            // });
            // console.log({ dragElClassList, relatelClassList });

            // 不同层级的不能互相拖动
            // 这里采用比较笨的方法实现,大佬们指点一下有什么更好的实现
            // isEqual采用lodash的方法，判断两个值是否相等
            // if (!isEqual(dragElClassList, relatelClassList)) return false;
            // return true;
          },
          onEnd: (event) => {
            // console.log('on end', event);
            // console.log(event);

            const { item, oldIndex } = event
            const options = { children: "children" };
            const targetTrElem = item;
            const wrapperElem = targetTrElem.parentNode;
            const prevTrElem = targetTrElem.previousElementSibling;
            const tableData = this.gridOptions.data;


            // console.log(xTable.getRowNode(targetTrElem), targetTrElem);

            if (!xTable.getRowNode(targetTrElem)) {
              return
            }

            const selfRow = xTable.getRowNode(targetTrElem).item;
            const selfNode = XEUtils.findTree(
              tableData,
              (row) => row === selfRow,
              options
            );

            if (prevTrElem) {
              // 移动到节点
              const prevRow = xTable.getRowNode(prevTrElem).item;
              const prevNode = XEUtils.findTree(
                tableData,
                (row) => row === prevRow,
                options
              );
              // console.log({ pre: prevNode.item['1054001'] }, { self: selfNode.item['1054001'] });

              // console.log({ prevRow })
              const { seq: preSeq = '' } = prevNode.item, { seq: selfSeq } = selfNode.item;


              const compareSeq = compareArr(preSeq, selfSeq);

              if (!compareSeq) {
                const oldTrElem = wrapperElem.children[oldIndex + 1];
                // console.log({ oldTrElem, wrapperElem });



                wrapperElem.insertBefore(targetTrElem, oldTrElem);
                // const [row] = tableData;
                // const arr = this.getItemSeq(row.children);
                // console.log(arr);

                // 如果变动了树层级，需要刷新数据
                // this.gridOptions.data = [...tableData];
                // console.log(this.gridOptions.data);
                // this.saveSceduleOrder(arr);
                // this.drop = true;
                // this.$message.error("不允许跨级拖动！")
                return
              }
              if (
                XEUtils.findTree(
                  selfRow[options.children],
                  (row) => prevRow === row,
                  options
                )
              ) {
                // 错误的移动
                const oldTrElem = wrapperElem.children[oldIndex];
                wrapperElem.insertBefore(targetTrElem, oldTrElem);
                return this.$message.error("不允许自己给自己拖动！");
              }
              const currRow = selfNode.items.splice(selfNode.index, 1)[0];
              if (xTable.isTreeExpandByRow(prevRow)) {
                // 移动到当前的子节点

                // console.log('children', currRow);

                prevRow[options.children].splice(0, 0, currRow);
              } else {
                // 移动到相邻节点

                // console.log('labor', prevNode, prevNode.item['1054001']);

                // console.log('sdfasdf', { name: prevNode.item['1054001'], item: prevNode.item, index: prevNode.index }, { name: selfNode.item['1054001'], item: selfNode.item, index: selfNode.index });

                // console.log('---index', prevNode.index + (selfNode.index < prevNode.index ? 0 : 1),);

                prevNode.items.splice(
                  prevNode.index + (selfNode.index < prevNode.index ? 0 : 1),
                  0,
                  currRow
                );
              }
            } else {
              // 移动到第一行
              const currRow = selfNode.items.splice(selfNode.index, 1)[0];
              tableData.unshift(currRow);
            }
            // console.log(tableData);
            const [row] = tableData;
            const arr = this.getItemSeq(row.children);
            // console.log(arr);

            // 如果变动了树层级，需要刷新数据
            this.gridOptions.data = [...tableData];
            // console.log(this.gridOptions.data);
            this.saveSceduleOrder(arr);
            this.drop = true;
          },

        });
      });
    },
    setArr(arr) {
      const obj = {};

      const getAA = (list) => {
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          const { id, seq, children = [] } = element
          id && (obj[id] = seq);
          if (children.length) {
            getAA(element.children)
          }
        }
        return obj
      }
      return getAA(arr)

    },
    saveSceduleOrder(arr) {
      const obj = this.setArr(arr)
      return axios.post(`/ppm/project/updatewbs`, obj);
    },
    getCascaderLabel(row) {
      if (row["1054008"]) {
        const list = row["1054008"] || [];

        const nameList = list.map((i) => {
          const arr = Array.isArray(i) ? i : i.split(",");
          const val = arr.at(-1);

          // const val = Array.isArray(i) ? i.at(-1) : i;
          const name = this.allProList.find((j) => j.value == val)?.label;
          return name;
        });

        // const newRow = row["1054008"].join(";");
        // const arr = newRow.split(";").map((i) => {

        //   const id = i.split(",").at(-1)
        //   return id
        //   // const id = list.at(-1).replace('_1', '');
        //   // const tenantName = window.sessionStorage.getItem("tenantName");
        //   // if (tenantName.indexOf('demo') !== -1) {
        //   //   id = list.at(-1).replace('_1', '');
        //   // }
        //   // this.isDemoTenant && (id = id.replace('_1', ''))
        //   // arr.push(id);
        // });
        // const list = this.allProList
        //   .filter((j) => arr.includes(j.value + ""))
        //   .map((i) => i.label);

        return nameList.join(" ; ");
      } else {
        return "";
      }
    },

    sum(arr) {
      var s = 0;
      arr.forEach(function (val, idx, arr) {
        s += val;
      }, 0);
      return s;
    },

    formatAmount({ row, column, cellValue }) {
      return cellValue
        ? `￥${XEUtils.commafy(XEUtils.toNumber(cellValue), { digits: 2 })}`
        : `￥0.00 `;
    },

    editActivedEvent({ row, column }) {
      this.getDurationVal = this.getDuration(row);
      this.testData = row;
      this.updateTypeList({ row, column });
      this.updatePrevTaskist(this.cascaderList, row, column);
    },

    setScheduleDate(val, row) {
      let st = row["1054009"],
        et = row["1054010"];

      if (val) {
        row["1054011"] = Number(val) * 24 * 60 * 60 * 1000;
        if (st || et) {
          let day = !st
            ? this.countStartDate(val, et)
            : this.countEndDate(val, st);
          const key = !st ? "1054009" : "1054010";

          const func = !st ? "startTimeChange" : "endTimeChange";
          row[key] = day;

          this[func](row);
          this.changData.push({ id: row.id, [key]: row[key] });
        }
      }
    },

    updatePnameList(row) { },
    updateEvent({ cellValue }) {
      this.$refs.xGrid.loadData();
    },
    activeCellMethod({ column, row }) {
      const VALID_FIELD_VALUES = ["1054012", "1054013"];
      if (VALID_FIELD_VALUES.includes(column.field) && row.isLeaf == 0) {
        return false;
      }
      if (!row.id) {
        return !ACTIVE_LIST.includes(parseInt(column.property));
      }
      if (
        !this.rowList.includes(row.id) ||
        (row.id == this.rootId && column.property == 1054008)
      ) {
        return false;
      }
      if (column.property == 1054071) {
        return true;
      }
      //项目-计划中的实际开始/结束日期先特殊处理为可编辑
      if (column.property == 1054012 || column.property == 1054013) {
        return true;
      }

      if (column.property == 1054011) {
        return true;
      }
      //
      let n = [];
      // 判断表格中是否允许编辑
      let getEditable = (arr, id) => {
        arr.map((i) => {
          if (i.objId == id) {
            return (n = i);
          } else {
            i.children && getEditable(i.children, id);
          }
        });
        return n;
      };
      return getEditable(this.editableList, row.id).cells.find(
        (i, e) => this.columnList.ids[e] == column.property
      ).editable;
    },

    updateTypeList({ row, column }) {
      const { editRender, property } = column;
      const val = row[property];

      const { options = [] } = editRender;
      const arr = options
        .map((i) => {
          i.order = val.includes(i.value) ? 2 : 1;
          return i;
        })
        .sort((a, b) => b.order - a.order);
      editRender.options = arr;

      if (column.property == 1054071) {
        // if (row.id) {
        //   const list = this.baseData.find(i => i.id == row.id)['1054071'].map(i => i + '')
        //   this.ccList.map(i => i.disabled = list.includes(i.value));
        // } else {
        //   this.ccList.map(i => i.disabled = false);
        // }
      } else {
        if (!!row.id) {
          this.subList.map(
            (i) =>
              (i.disabled = !i.options.some((j) => j.value == row["1054006"]))
          );
        } else {
          this.subList.map((i) => {
            i.disabled = false;
          });
        }
      }
    },
    updatePrevTaskist(arr, row, column) {
      if (column.property != 1054008) {
        return;
      }
      const fun = (list, id) => {
        list.map((i) => {
          i.disabled = i.value == row.id + "_1";

          if (i.children?.length === 1) {
            const [item] = i.children;
            i.disabled = item.value == row.id + "_1";
          }

          if (i.children?.length) {
            fun(i.children, id);
          }
        });
      };
      return fun(arr, row.id);
    },

    editDisabledEvent({ row, column }) {
      this.$message.error(this.$t("message.error.noEdit"));
    },

    formatDate(value, format) {
      return XEUtils.toDateString(value, format);
    },
    showDetailEvent(row) {
      const { id, classId, subclassId: subClassId, parentId } = row;

      const currentRouteId = this.$router.currentRoute.query.id;
      if (currentRouteId === String(id)) {
        return;
      }

      const obj = {
        id,
        classId,
        subClassId,
        parentId,
        title: row["1054001"],
        rootId: this.rootId,
      };
      this.getLink(obj);
    },
    getCalendar() {
      this.$http
        .get("/ppm/calendar/loadCalendar?year=" + new Date().getFullYear())
        .then((res) => {
          this.calendarList = res.data.object;
          this.cList = this.calendarList.map(
            (i) => i.exceptionDate.split("T")[0]
          );
        });
    },
    loadUserPriv() {
      var priv_ = this.getUserContextPriv();
      let subClass_Id = this.objectId.subClassId;
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          if (priv_[i].type == 15) {
            //打印按钮
            this.tableToolbar.print = true;
          }
        }
      }
      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (isSupAdmin) {
        this.tableToolbar.print = true;
      }
    },
    // disabledDate: (time) => {
    //   const st = this.columnInfo.find(
    //     (i) => i.id == 1054010
    //   ).index;
    //   return (
    //     time.getTime() < (Date.parse(this.pageData[[st]]) -24*60*60*1000)
    //   );
    // },
    // dragColumn(){
    //   return {
    //     width: 60,
    //     // fixed:'left',
    //     slots: {
    //       default: () => {
    //         return [
    //           <span class="drag-btn">
    //             <i class="vxe-icon--menu"></i>
    //           </span>
    //         ]
    //       },
    //       header: () => {
    //         return [
    //           <vxe-tooltip v-model={ this.showHelpTip } content="按住后可以上下拖动排序！" enterable>
    //             <i class="vxe-icon--question" onClick={ () => { this.showHelpTip = !this.showHelpTip } }></i>
    //           </vxe-tooltip>
    //         ]
    //       }
    //     },
    //   }
    // }
    //通过获取当前的租户来判断实际开始/结束时间的选择范围
    //如果是租户为tianbian则通过setupPickerOptionsACT修改两个实际时间只能选择为当天
    getTenantName() {
      let systemName;
      try {
        systemName = window.sessionStorage.getItem("systemName");
      } catch (error) {
        systemName = "";
      }
      if (systemName === "tianbian") {
        this.setupPickerOptionsACT();
      }
    },
    setupPickerOptionsACT() {
      this.pickerOptionsStartACT = {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          return (
            time.getTime() < today.getTime() ||
            time.getTime() >= tomorrow.getTime()
          );
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time),
      };
      this.pickerOptionsEndACT = {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1);
          const timeData = this.testData[1054012];
          if (Date.parse(timeData)) {
            return (
              time.getTime() < today.getTime() ||
              time.getTime() >= tomorrow.getTime()
            );
          } else {
            return true;
          }
        },
        firstDayOfWeek: 1,
        cellClassName: (time) => this.calendarDate(time),
      };
    },
  },
  computed: {
    reloadProjectBtnPrv() {
      return this.$store.state.reloadProjectBtnDisable;
    },
    AllProjectBtnPrv() {
      return this.$store.state.AllProjectBtnDisable;
    },
    loadIsProjectAdmin() {
      return this.$store.state.isProjectAdmin;
    },
    loadIsProjectDirector() {
      return this.$store.state.isProjectDirector;
    },

    ccList() {
      return this.$store.state.userList;
    },
  },

  watch: {
    reloadProjectBtnPrv: {
      handler(val) {
        this.editTable = val;
      },
      deep: true,
      immediate: true,
    },
    AllProjectBtnPrv: {
      handler(val) {
        this.btnEditTable = val;
      },
      deep: true,
      immediate: true,
    },
    loadIsProjectAdmin: {
      handler(val) {
        this.btnIsProjectAdmin = val;
      },
      deep: true,
      immediate: true,
    },
    loadIsProjectDirector: {
      handler(val) {
        //this.btnIsProjectDirector = val;
        let isSupAdmin = this.$store.state.isSuperAdmin;
        if (!this.btnIsProjectAdmin && !val && !isSupAdmin) {
          this.btnIsAdmin = false;
          this.isExecuter = false;
        } else {
          this.btnIsAdmin = true;
          this.isExecuter = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  updated() { },
  mounted() {
    this.getTab();
    this.getScheduleInfo();
    this.rowDrop();
    this.$nextTick(() => {
      this.$refs.xGrid.setAllRowExpand(true);
    });
  },
  created() {
    this.getCalendar();
    this.loadUserPriv();

    const tenantName = window.sessionStorage.getItem("tenantName");

    this.isDemoTenant = tenantName.indexOf("weile") != -1;
    // this.$nextTick(() => {
    //     // this.tableHeight =  this.$refs.tablePage.offsetHeight
    //   })
    this.getTenantName();
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  },

  beforeRouteLeave(to, from, next) {
    console.log(to, from);
    const tabs = [...this.$store.state.showingTabsInHome];
    const activeName = this.$store.state.activedTabInHome;
    if (!this.$store.state.pageChanged) {
      //就是上面的状态 如果是true , 则不询问是否保存, 当然这个方法比较笨, 大家可以使用更优雅的方式
      next();
    } else {
      this.$confirm("当前页面有未保存信息，确定离开么", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.commit("setPageChanged", {
            name: this.componentname,
            isChanged: false,
          });
          next();
          if (to.path == from.matched[1].path) {
            this.$store.commit("setPageRefresh");
          }
        })
        .catch(() => {
          this.$store.commit("replaceShowingTabsInHome", tabs);
          this.$store.commit("setActivedTabInHome", activeName);
        });
    }
  },
};
</script>

<style>
.date-pick-holiday span {
  color: #fff;
  background: #a0cfff;
  border-radius: 8% !important;
}
</style>
<style scoped>
.sortable-tree-demo .drag-btn {
  cursor: move;
  font-size: 12px;
}

.sortable-tree-demo .vxe-body--row.sortable-ghost,
.sortable-tree-demo .vxe-body--row.sortable-chosen {
  background-color: #dfecfb;
}

.name-squ {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-top: 5px;
  border-radius: 2px;
}

.table {
  /* padding: 0 15px; */
  background: #fff;
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  margin-left: 20px;
  height: 57px;
}

.content-title li {
  float: left;
  padding: 18px 12px 12px 12px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}
</style>
